import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";

import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IAppState } from "../../../store/reducers";
import { useSelector } from "react-redux";
import { ReportsService } from "../../../services/ReportsService";
import { EarningsService } from "../../../services/EarningsService";
import { IGetListRequest } from "../../../models";
import { DeductionsService } from "../../../services/DeductionsService";
import { ReimbursementsService } from "../../../services/ReimbursementsService";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";

interface IEDRReportHeader {
	employeeDDLitems?: { label: string; value: any }[];
	dateDDL: any;
	onPeriodSelectionChangeHandler: (value: string) => void
	payFrequencyDDLItems: any;
	formMethods: any
	selectedPayPeriod: any,
	setStateRunGetListAPICall: (value: boolean) => void
}

export const EDRReportHeader: React.FC<
	IEDRReportHeader
> = ({ employeeDDLitems, dateDDL, onPeriodSelectionChangeHandler, payFrequencyDDLItems, formMethods, selectedPayPeriod, setStateRunGetListAPICall }) => {

	const [selectedType, setSelectedType] = useState<any>("all");
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const [edrDdl, setEdrDdl] = useState<any>([
		{ label: "All", value: "all" }
	])
	const onEarningTypeSelectionChangeHandler = async (event: any) => {
		let selectedItem = event.value
		setSelectedType(selectedItem)
		formMethods.setValue("edr", "all")
		if (selectedItem !== "all") {
			(async () => {
				try {
					const response = await ReportsService.getEDRDDL(clientId, selectedItem);
					if (response) {
						if (
							response &&
							Array.isArray(response)
						) {
							let edr: IDropDownListResponse[] =
								response.map(
									(resourceItem: IDropDownListResponse) => ({
								
										label: resourceItem.label,
										value: resourceItem.value,
									})
								);

							edr.unshift({
								label: "All",
								value: "all",
							});
						
							setEdrDdl(edr)
						}
					}
				} catch { }
			})();
		}
	};

	const onPayPeriodSelectionChangeHandler = (e: any) => {
		formMethods.setValue('endDate', undefined)
		onPeriodSelectionChangeHandler(e.value);
		setStateRunGetListAPICall(false)
	}

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
					// sx={{ mt: "12px" }}
					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {

						},

					}}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employee"}
						items={employeeDDLitems ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName="payPeriod"
						items={payFrequencyDDLItems ?? []}
						label={"Pay Period"}
						testId={"pay-period"}
						selectedItem={"all"}
						onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}

					/>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<EnhancedDropDownRHFWithLabel
						label="End date"
						selectName="endDate"
						testId={`end-date`}
						labelPosition={LabelPosition.Top}
						items={dateDDL ?? []}
						// selectedItem={"all"}
						isDisabled={selectedPayPeriod === null || selectedPayPeriod === "all"}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName={"type"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Earning",
								value: "earnings",
							},
							{
								label: "Deduction",
								value: "deduction",
							},
							{
								label: "Reimbursement",
								value: 'reimbursement',
							},
						]}
						label={"Type"}
						testId={"type-edr"}
						selectedItem={selectedType}
						onSelectionChangeHandler={onEarningTypeSelectionChangeHandler}
					/>

				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
				{selectedType !== "all" && <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"edr"}
						items={edrDdl ?? []}
						selectedItem={"all"}
						label={selectedType === 'earnings' ? "Earning" : selectedType === 'deduction' ? "Deduction" : selectedType === 'reimbursement' ? "Reimbursement" : selectedType}
						testId={`${selectedType}-type`}
					/>
				</Grid>}

			</Grid>
		</>
	);
};

